import { DINING_OPTION_BEHAVIORS } from '../../utils/dining-options'
import { isFulfillmentTimeValid } from '../FulfillmentSelectorModal/fulfillment-helpers'

export const FULFILLMENT_TYPES = {
  ASAP: 'ASAP',
  FUTURE: 'FUTURE'
}

const { TAKE_OUT, DELIVERY } = DINING_OPTION_BEHAVIORS
const { ASAP, FUTURE } = FULFILLMENT_TYPES

const availabilityError = {
  error: new Error('Ordering not available')
}

export const initialReducerState = ({fulfillmentStorage, availability, orderingAvailable}) => {
  const { get } = fulfillmentStorage
  const fulfillmentType = get('fulfillmentType') || ASAP
  const fulfillmentTime = get('fulfillmentTime') || null
  const diningOptionBehavior = get('diningOptionBehavior') || TAKE_OUT

  if (!orderingAvailable) return availabilityError
  const def = {
    deliveryInfo: get('deliveryInfo') || undefined,
    deliveryProvider: null,
    savedAddressGuid: null,
    fulfillmentTime,
    valid: isFulfillmentTimeValid(fulfillmentTime, fulfillmentType),
    selected: false
  }

  if (availability[fulfillmentType][diningOptionBehavior]) {
    return {
      ...def,
      fulfillmentType,
      diningOptionBehavior,
      selected: Boolean(get('fulfillmentType'))
    }
  }

  if (availability[ASAP][TAKE_OUT]) {
    return {
      ...def,
      fulfillmentType: ASAP,
      fulfillmentTime: null,
      diningOptionBehavior: TAKE_OUT
    }
  }

  if (availability[FUTURE][TAKE_OUT]) {
    return {
      ...def,
      fulfillmentType: FUTURE,
      diningOptionBehavior: TAKE_OUT
    }
  }

  if (availability[ASAP][DELIVERY]) {
    return {
      ...def,
      fulfillmentType: ASAP,
      fulfillmentTime: null,
      diningOptionBehavior: DELIVERY
    }
  }

  if (availability[FUTURE][DELIVERY]) {
    return {
      ...def,
      fulfillmentType: FUTURE,
      diningOptionBehavior: DELIVERY
    }
  }

  return availabilityError
}
